module.exports = __webpack_public_path__ + "media/assets/icons/bar-chart-icon-purple-3bf8bfb6e829ac46e9aeffb5ae5d8665.png";